import { push } from "connected-react-router";
import enums from "../enums";
import Service from "../service/index.jsx";

export function goToLink(link) {
	return (dispatch) => {
		dispatch(push(link));
	};
}

export function goToLinkWithParams(link, params) {
	return (dispatch) => {
		dispatch(push({ pathname: link, state: params }));
	};
}
export function getConfiguration(params) {
	return (dispatch) => {
		Service.get("tenant-api", "configurations", {
			params,
		}).then((res) => dispatch({ type: enums.SET_CONFIG, payload: res.data }));
	};
}
export function addAffiliate(params) {
	return Service.post("affiliate-api", "applications", params);
}
